function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Shape } from "./Shape.js";
import { PropTypes } from "./PropTypes.js";
export const client = arg => {
  return _objectSpread(_objectSpread({}, arg), {}, {
    _client: true
  });
};
export const query = (args, queryArg) => {
  return _objectSpread(_objectSpread({}, queryArg), {}, {
    _query: args
  });
};
export const arrayOf = model => {
  const children = model._children ? model._children : model;

  // const _query = model._query;
  if (model.query) {
    children._query = model.query;
  } else if (model._query) {
    children._query = model._query;
  }
  if (model._customType) {
    var _children$_value;
    children._value = model._subType;
    if (model._isRequired && ((_children$_value = children._value) === null || _children$_value === void 0 ? void 0 : _children$_value.charAt(children._value.length - 1)) !== '!') {
      children._value += '!';
    }
  }
  return new PropTypes('Object', {
    isArray: true,
    children
  });
};
export const string = () => {
  return new PropTypes('String');
};
export const id = () => {
  return new PropTypes('ID');
};
export const json = () => {
  return new PropTypes('JSON');
};
export const number = function () {
  let {
    float = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const type = float ? 'Float' : 'Int';
  return new PropTypes(type);
};
export const bool = () => {
  return new PropTypes('Boolean');
};
export const params = args => {
  let addClient = false;
  let mutation = false;
  return {
    // model(model) {
    //   const  model;
    // },
    shape(model) {
      if (model.type === 'Object' && model._children) {
        // eslint-disable-next-line no-param-reassign
        model = model._children;
      }
      const ret = new Shape(_objectSpread(_objectSpread({}, model), {}, {
        _mutation: mutation,
        _client: false
      }));
      ret._query = args;
      if (addClient) {
        return this._addClient(ret);
      }
      return ret;
    },
    arrayOf(model) {
      if (model instanceof PropTypes) {
        // String or primiative types as array children Will
        // not have model.type === 'Object'
        // you dont want to assign query to them. assign to the ret.
        if (model.type === 'Object') {
          // eslint-disable-next-line no-param-reassign
          model._query = args;
        }
        const ret = arrayOf(model);
        if (model.type !== 'Object') {
          ret._query = args;
        }
        ret._mutation = mutation;
        return ret;
      }
      return arrayOf(this.shape(model));
    },
    client() {
      addClient = true;
      return this;
    },
    mutation() {
      mutation = true;
      return this;
    },
    string() {
      return this.shape(string());
    },
    _addClient(model) {
      return Object.keys(model).map(key => {
        if (/^_/.test(key)) {
          return {
            [key]: model[key]
          };
        }
        return {
          [key]: _objectSpread(_objectSpread({}, model[key]), {}, {
            _client: true
          })
        };
      }).reduce((acc, cur) => {
        return _objectSpread(_objectSpread({}, acc), cur);
      }, {});
    }
  };
};
export const alias = aliasName => {
  return {
    params() {
      const args = params(...arguments);
      return {
        shape(model) {
          const ret = args.shape(model);
          return _objectSpread(_objectSpread({}, ret), {}, {
            _alias: aliasName
          });
        },
        arrayOf(model) {
          const ret = arrayOf(this.shape(model));
          ret._alias = aliasName;
          return ret;
        }
      };
    }
  };
};
export const shape = function (model) {
  let subType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Object';
  Object.keys(model).forEach(key => {
    if (typeof model[key] === 'function') {
      // eslint-disable-next-line max-len
      throw new Error(`The property type for '${key}' must be invoked! You may also be trying to use a react 'prop-type' when you should be using a data-source prop-type.`);
    }
  });

  // remove any keys with _
  // dont want to apply params when directly invoking
  // shape(). for params use params().shape()
  const children = Object.keys(model).map(key => {
    if (/^_/.test(key) && key !== '__typename') return null;
    return {
      [key]: model[key]
    };
  }).filter(val => val).reduce((acc, cur) => {
    return _objectSpread(_objectSpread({}, acc), cur);
  }, {});
  return new PropTypes('Object', {
    isArray: false,
    children,
    subType
  });
};

// For querying shapes that are part of a union
// applies inline fragment syntax in written query, e.g. "... on Hero"
export const fragment = () => {
  return {
    shape(model) {
      const ret = shape(model);
      return _objectSpread(_objectSpread({}, ret), {}, {
        _inlineFragment: true,
        _namedFragment: false
      });
    }
  };
};

/*
-----------------
DO NOT USE unless:
- the inner body of the query would be repeated multiple times in an experience level query.
- the experience level query has a large REQUEST payload
-----------------
inline - determines whether to apply inline fragment syntax, e.g. "... on  Hero" vs "Hero"
fragmentType - the type in your api schema
fragmentAlias - if provided, overrides the default fragment name for a given type.
*/
export const namedFragment = _ref => {
  let {
    inline = false,
    fragmentType = '',
    fragmentAlias = ''
  } = _ref;
  if (!fragmentType) {
    // eslint-disable-next-line max-len
    throw new Error('You must supply a fragmentType when using namedFragment. This should match the type in your api schema. ');
  }
  return {
    shape(model) {
      const ret = shape(model);
      return _objectSpread(_objectSpread({}, ret), {}, {
        _inlineFragment: inline,
        _namedFragment: !!fragmentType,
        _fragmentType: fragmentType,
        _fragmentAlias: fragmentAlias
      });
    }
  };
};
export const typename = defaultName => {
  const ret = shape({
    type: 'typename'
  }, '__typename');
  ret._typename = {
    defaultName
  };
  return ret;
};
export const customType = typeName => {
  return {
    shape(model) {
      return shape(model, typeName);
    },
    enum(values, defaultValue) {
      const ret = shape({}, typeName);
      ret._enum = values.reduce((acc, cur) => {
        return _objectSpread(_objectSpread({}, acc), {}, {
          [cur]: true
        });
      }, {});
      if (defaultValue) {
        ret._defaultValue = defaultValue;
      }
      return ret;
    }
  };
};
//# sourceMappingURL=index.js.map